import { gql } from '@apollo/client';

// Hand-written types: production introspection is off.

export interface SoundEffectRow {
  id: string;
  category: string;
  name: string;
  tags: string[];
  duration: number;
  peak_at: number;
  url: string;
}

export interface SoundEffectsQueryData {
  soundEffects: SoundEffectRow[];
}

export interface SoundEffectsQueryVars {
  query?: string | null;
  category?: string | null;
  locale?: string | null;
  limit?: number | null;
}

export const SOUND_EFFECTS = gql`
  query SoundEffects($query: String, $category: String, $locale: String, $limit: Int) {
    soundEffects(query: $query, category: $category, locale: $locale, limit: $limit) {
      id
      category
      name
      tags
      duration
      peak_at
      url
    }
  }
`;

export interface SoundEffectsPage {
  items: SoundEffectRow[];
  total: number;
  has_more: boolean;
}
export interface BrowseSoundEffectsData { browseSoundEffects: SoundEffectsPage }
export interface BrowseSoundEffectsVars extends SoundEffectsQueryVars {
  region?: 'br' | 'us' | null;
  offset: number;
}

export const BROWSE_SOUND_EFFECTS = gql`
  query BrowseSoundEffects($query: String, $category: String, $region: String, $locale: String, $limit: Int, $offset: Int) {
    browseSoundEffects(query: $query, category: $category, region: $region, locale: $locale, limit: $limit, offset: $offset) {
      items { id category name tags duration peak_at url }
      total
      has_more
    }
  }
`;
